import { ctxReport } from '@/contexts/ReportCtx';
import { ReportTabs, ReportTabValue } from '@/types';
import { useCallback, useContext } from 'react';
import CategorySelector from './CategorySelector';
import ReportDriverSelector from './ReportDriverSelector';
import ReportTargetSelector from './ReportTargetSelector';
import { ReportData } from './ReportData';
import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import Box from '@mui/material/Box';
import { JSX } from 'react';

export function ReportMobileBody() {
  const reportCtx = useContext(ctxReport);

  const resetContext = useCallback(
    (tab: ReportTabs) => {
      if (reportCtx?.lastVisitedTab !== tab) reportCtx?.setSelectedTemplateIds([]);
      reportCtx?.setTab(ReportTabValue.entitySelect);
      if (tab === 'TargetTab') {
        reportCtx?.setSelectedDrivers([]);
      } else {
        reportCtx?.setSelectedTargets([]);
      }
    },
    [reportCtx]
  );

  if (!reportCtx) return;

  function setSelectedDatesWrapper(from: Date, to: Date) {
    reportCtx?.setSelectedDates({ from, to });
    reportCtx?.setTab(ReportTabValue.categorySelect);
  }

  function updateActiveTab(tab: ReportTabs) {
    resetContext(tab);
    reportCtx?.setLastVisitedTab(tab);
  }

  switch (reportCtx?.tab) {
    case ReportTabValue.dateSelect:
      return <StaticDateRangeSelect setSelectedDates={setSelectedDatesWrapper} />;
    case ReportTabValue.categorySelect:
      return <CategorySelector setActiveTab={updateActiveTab} isPhone={true} />;
    case ReportTabValue.result:
      return <ReportData isListView={true} />;
    case ReportTabValue.entitySelect: {
      const selectors: Record<string, JSX.Element> = {
        TargetTab: <ReportTargetSelector />,
        DriverTab: <ReportDriverSelector />,
      };

      return <Box className="selector-box">{selectors[reportCtx.lastVisitedTab]}</Box>;
    }
  }
}
